import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHeadContainer = styled.div<{ $expanded: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 26px 30px 16px;
	${({ $expanded }) =>
		$expanded &&
		css`
			cursor: pointer;
		`}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledBody = styled.div`
	padding: 0 30px 30px;
`;

const StyledExpandButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition:
			rotate 0.3s ease,
			filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledContainer = styled.div<{ $expanded: boolean; $height: number }>`
	width: 440px;
	height: ${(props) => props.$height}px;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;

	${(props) =>
		props.$expanded
			? css`
					${StyledExpandButton} img {
						rotate: 180deg;
					}
			  `
			: css`
					height: 71px;
					cursor: pointer;
			  `}
	transition: height 0.25s ease;
`;

export { StyledBody, StyledContainer, StyledExpandButton, StyledHeadContainer };
